module.exports = __webpack_public_path__ + "img/4.465f500a.jpg";